module.exports = __webpack_public_path__ + "static/assets/4bff31ef1921ee2f0b1e629d49c02c68.svg";